import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import Moment from 'moment';
import {
  fetchAccountPositions,
  fetchQuotesChartData,
  fetchQuotesSnapQuote,
  fetchQuotesEnhancedSnapQuote,
} from '../../actions';

import SecurityDetail from './SecurityDetail';

const prepQuoteMediaDataForChart = data => (
  data.map(item => ({
    date: item.date,
    marketValue: String(item.close),
  })));

const prepQuoteMediaIntervalDataForChart = data => (
  data.map(item => ({
    date: item.startdatetime,
    marketValue: String(item.close),
  })));
class SecurityDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      isChartDataLoading: false,
    };
  }
  componentDidMount() {
    const {
      accountNumber,
      securityId,
    } = this.props;
    if (accountNumber !== '') this.props.fetchAccountPositions(accountNumber);
    this.props.fetchQuotesSnapQuote(securityId);
    this.props.fetchQuotesEnhancedSnapQuote(securityId);
  }
  onRangeChange = async (value, units) => {
    const range = Moment.duration(value, units);
    const start = new Moment().subtract(range).format('YYYY-MM-DD');
    let interval = 60;
    const days = range.as('days');
    if (days < 2) {
      interval = 1;
    } else if (days < 8) {
      interval = 15;
    }
    this.setState({ isChartDataLoading: true });
    const chartData = await this.props.fetchQuotesChartData(this.props.securityId, start, interval);
    this.setState({ isChartDataLoading: false, chartData });
  };
  render() {
    const {
      positions,
      securityId,
      priceData,
      enhancedPriceData,
    } = this.props;
    const position = positions.filter(pos => (get(pos, 'security.ticker') === securityId))[0];
    const costBasis = get(position, 'shortTermCostBasis', '0.00') === '0.00' ?
      get(position, 'longTermCostBasis', '0.00') : get(position, 'shortTermCostBasis', '0.00');
    const purchasePrice = Number.isFinite(Number.parseFloat(get(position, 'shareQuantity', null))) ?
      costBasis / Number.parseFloat(get(position, 'shareQuantity')) : null;
    const currentChange = purchasePrice && get(priceData, 'last') ?
      ((get(priceData, 'last') - purchasePrice) / purchasePrice) * 100 : null;
    const security = {
      securityId: get(position, 'security.ticker'),
      currentPrice: get(priceData, 'last', null),
      purchasePrice,
      currentChange,
      changepercent: get(priceData, 'changepercent', null),
      cost: Number.parseFloat(costBasis),
      value: get(priceData, 'last', 0) * get(position, 'shareQuantity', null),
      dayHigh: get(priceData, 'high', null),
      dayLow: get(priceData, 'low', null),
      openPrice: get(priceData, 'open', null),
      bid: get(priceData, 'bid', null),
      ask: get(priceData, 'ask', null),
      fiftyTwoWeekHigh: get(enhancedPriceData, 'week52high.content'),
      fiftyTwoWeekLow: get(enhancedPriceData, 'week52low.content'),
      sharevolume: get(priceData, 'sharevolume', null),
      name: `${get(position, 'security.companyName', '')} (${get(position, 'security.ticker', '')})`,
      quantity: get(position, 'shareQuantity') ? Number.parseFloat(get(position, 'shareQuantity')) : null,
    };
    const chartValues = prepQuoteMediaDataForChart(get(this.state.chartData, 'history[0].eoddata', []));
    const chartDetailValues = prepQuoteMediaIntervalDataForChart(get(this.state.chartData, 'intraday[0].interval', []));
    return (
      <SecurityDetail
        chartValues={chartValues}
        chartDetailValues={chartDetailValues}
        security={security}
        onRangeChange={this.onRangeChange}
        isChartDataLoading={this.state.isChartDataLoading}
      />
    );
  }
}

SecurityDetailContainer.defaultProps = {
  quoteChartData: [],
};

const mapStateToProps = (state, { match: { params: { securityId } } }) => ({
  authToken: state.authToken,
  user: state.authTokenUser,
  positions: get(state, `accountPositionsByAccount[${get(state, 'currentAccount', '')}].data`, []),
  accountNumber: get(state, 'currentAccount'),
  priceData: get(state, `quoteData['${securityId}'].pricedata`),
  enhancedPriceData: get(state, `enhancedQuoteData['${securityId}'].pricedata`),
  securityId,
});

const mapDispatchToProps = {
  fetchAccountPositions,
  fetchQuotesChartData,
  fetchQuotesSnapQuote,
  fetchQuotesEnhancedSnapQuote,
};

export default connect(mapStateToProps, mapDispatchToProps)(SecurityDetailContainer);



// WEBPACK FOOTER //
// ./src/components/SecurityDetail/index.js